{
  "labels": {
    "textSingleLine": "Teks - Satu Baris",
    "textMultipleLines": "Teks - Beberapa Baris",
    "date": "Tanggal",
    "trueFalse": "Benar/Salah",
    "singleDocument": "Dokumen Tunggal",
    "multiDocument": "Beberapa Dokumen",
    "number": "Angka",
    "eMail": "Email",
    "phone": "Telepon",
    "dropDownSingleSelectList": "Daftar Tarik-Turun Pilihan Tunggal",
    "dropDownMultiSelectList": "Daftar Tarik-Turun Pilihan Ganda",
    "comboBox": "Kotak Kombo",
    "timestamp": "Stempel Waktu",
    "featureLink": "Tautan Fitur"
  },
  "descriptions": {
    "openTextFieldSingleLine": "Kolom teks bebas, satu baris",
    "openTextFieldMultipleLines": "Kolom teks bebas, beberapa baris",
    "formatMmDdYyyy": "Format BB/HH/TTTT",
    "toggleButton": "Tombol Alih",
    "singleFileUploadField": "Kolom unggah satu file",
    "multipleFileUploadField": "Kolom unggah beberapa file",
    "numericInputField": " Kolom input angka",
    "emailAddressInputField": "Kolom input alamat email",
    "format1XxxXxxXxxx": "Format +1(XXX) XXX-XXXX",
    "selectOneOptionFromAList": "Pilih satu opsi dari daftar",
    "selectMultipleOptionsFromAList": "Pilih beberapa opsi dari daftar",
    "singleOptionDropDownListOpenTextField": "Daftar tarik-turun satu opsi + kolom teks bebas",
    "dateAndTimeFields": "Kolom tanggal dan waktu",
    "linkToTheFormFeatures": "Tautan ke fitur formulir"
  }
}
